/**
 * @file   src\mobile\components\createWantAd\Property.js
 * @brief  This file is responsible for nice to haves section subcomponent
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import NiceToHaveHelper from "./NiceToHaveHelper";

const Property = (props) => {
  const { properties, itemArray, handleItemClick } = props;
  return (
    <NiceToHaveHelper
      list={properties}
      selectedItems={itemArray}
      propertyClick={handleItemClick}
    />
  );
};
export default Property;
